import _ from 'lodash'

/*eslint-disable no-console */
const canLog = function(allEnvironments = false) {
    return (allEnvironments || process.env.VUE_APP_LOG_DEBUG === 'true')
        && console && console.log
}

const consoleLogger = console
/*eslint-enable no-console */

export default {

    /**
     * Logs to the console only if present and not in a production build.
     * @param {string} message
     * @param {string} category
     */
    log(message, category) {
        if (canLog())
            consoleLogger.log(category ? `${ category.toUpperCase() }: ${ message }` : message)

    },

    /**
     * Logs an object to the console only if present and not in a production build.
     * @param {Object} objectVar
     * @param {string} message
     * @param {string} category
     */
    logObject(objectVar, message, category) {
        if (canLog()) {
            // noinspection JSUnresolvedVariable
            const isFirefox = typeof InstallTrigger !== 'undefined'
            const msgText = message
                ? category ? `${ category.toUpperCase() }: ${ message }` : message
                : category ? category.toUpperCase() : null
            if (objectVar && objectVar.toStoreJson) {
                try {
                    consoleLogger.log({ object: isFirefox ? _.cloneDeep(objectVar) : JSON.parse(JSON.stringify(objectVar)), json: JSON.parse(JSON.stringify(objectVar.toStoreJson())) }, msgText)
                } catch {
                    consoleLogger.log({ object: objectVar, json: JSON.parse(JSON.stringify(objectVar.toStoreJson())) }, msgText)
                }
            } else {
                try {
                    consoleLogger.log(isFirefox ? _.cloneDeep(objectVar) : JSON.parse(JSON.stringify(objectVar)), msgText)
                } catch {
                    consoleLogger.log(objectVar, msgText)
                }
            }
        }
    },

    /**
     * Logs a warning to the console only if present and not in a production build.
     * @param {string} message
     * @param {string} category
     */
    warn(message, category = 'WARNING') {
        if (canLog())
            consoleLogger.warn(`${ category.toUpperCase() }: ${ message }`)

    },

    /**
     * Logs an error to the console.
     * @param {string} message
     * @param {string} category
     */
    error(message, category = 'ERROR') {
        if (canLog(true))
            consoleLogger.error(`${ category.toUpperCase() }: ${ message }`)

    },

    /**
     * Logs a method call.
     * @param {string} methodName
     * @param {string} className
     * @param {?Object} parameterValues
     */
    trackMethod(methodName, className, parameterValues = null) {
        this.logObject(parameterValues, `${ className }: ${ methodName }`, 'Method Tracking')
    },
}
